import ReactLoader from 'components/Loader';
import React, { useState } from 'react';
import { PiStarFour } from 'react-icons/pi';
import * as S from '../styles';
import { DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { ChooseDialogTreeForm } from './components/ChooseDialogTreeForm';
import { ContainerItems } from '../LoginQueueChat/styled';

export const FlexIAServicePanel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const setLoadingState = (state) => {
    setIsLoading(state);
  };

  const toggleDropdown = () => setIsDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown nav isOpen={isDropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        className="nav-link"
        tag="a"
        style={{ cursor: 'pointer' }}
      >
        <div
          style={{
            border: '1px solid white',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px 10px 6px 10px'
          }}
        >
          <PiStarFour
            style={{
              color: 'white',
              fontSize: '20px',
              marginRight: '-5px'
            }}
          />
          <div
            className="statusRow"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 10px 0 10px'
            }}
          >
            <p style={{ color: 'white', margin: 0 }}>FlexIA Squad</p>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-xl py-0 overflow-y-visible" right>
        {isLoading ? (
          <S.LoadingWrapper>
            <ReactLoader height={50} width={50} />
          </S.LoadingWrapper>
        ) : (
          <ContainerItems>
            <ChooseDialogTreeForm
              setLoading={setLoadingState}
              setIsDropdownOpen={setIsDropdownOpen}
            />
          </ContainerItems>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};
